import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AppMode } from '../types/types';
import './BugReportButton.css';

import { Picto } from './common/Picto';
interface BugReportButtonProps {
  mode?: AppMode;
  currentLanguage?: string;
}

const BugReportButton: React.FC<BugReportButtonProps> = ({ mode, currentLanguage }) => {
  const { t } = useTranslation();
  const [tooltip, setTooltip] = useState(false);

  const handleClick = () => {
    const subject = encodeURIComponent(t('bugReport.mailSubject') as string);
    const context = [
      `${t('bugReport.contextPage')}     : ${window.location.pathname}`,
      `${t('bugReport.contextMode')}            : ${mode ?? t('bugReport.contextModeUnknown')}`,
      `${t('bugReport.contextLanguage')}          : ${currentLanguage ?? t('bugReport.contextLanguageUnknown')}`,
      `${t('bugReport.contextBrowser')}      : ${navigator.userAgent}`,
    ].join('\n');
    const body = encodeURIComponent(
      (t('bugReport.mailBody') as string) + '\n' + context
    );
    window.open(`mailto:jogolinga@gmail.com?subject=${subject}&body=${body}`, '_blank');
  };

  return (
    <button
      className="bug-report-fab"
      onClick={handleClick}
      onMouseEnter={() => setTooltip(true)}
      onMouseLeave={() => setTooltip(false)}
      aria-label={t('bugReport.ariaLabel') as string}
      title={t('bugReport.tooltip') as string}
    >
      <Picto name="signalerUnBug" />
      {tooltip && <span className="bug-report-fab__tooltip">{t('bugReport.tooltip')}</span>}
    </button>
  );
};

export default BugReportButton;
